module.exports = __webpack_public_path__ + "static/media/ic_paid_well_green.c70b75cc.svg";